import _defaults from 'lodash/defaults';

var root_services = '/srv';
var defaults = {
  serviceRoot: root_services,
  base: 'https://app.fitchconnect.com',
  login: '/authentication/login',
  user: root_services + '/users/v1',
  research: root_services + '/research/v1',
  entity: root_services + '/entity/v1',
  portfolio: '/portfolioenhc-ws',
  export: root_services + '/export/v1',
  nonce: root_services + '/nonce/v1',
  statements: root_services + '/statement/v1',
  owlinAdvanced: false,
  owlinEnv: 'production',
};
var prodUrl = 'app.fitchconnect.com';
export var envUrls = Object.create({
  'app.fitchconnect.com': _defaults(
    {
      base: 'https://app.fitchconnect.com',
      apiUrl: 'api.fitchconnect.com',
    },
    defaults
  ),
  'app.fitchconnect-dev.com': _defaults(
    {
      base: 'https://app.fitchconnect-dev.com',
      apiUrl: 'api.fitchconnect-dev.com',
      owlinAdvanced: true,
      owlinEnv: 'staging',
    },
    defaults
  ),
  'app.fitchconnect-int.com': _defaults(
    {
      base: 'https://app.fitchconnect-int.com',
      apiUrl: 'api.fitchconnect-int.com',
      owlinAdvanced: true,
      owlinEnv: 'staging',
    },
    defaults
  ),
  'app.fitchconnect-qa.com': _defaults(
    {
      base: 'https://app.fitchconnect-qa.com',
      apiUrl: 'api.fitchconnect-qa.com',
      owlinAdvanced: true,
      owlinEnv: 'staging',
    },
    defaults
  ),
  'app.fitchconnect-stg.com': _defaults(
    {
      base: 'https://app.fitchconnect-stg.com',
      apiUrl: 'api.fitchconnect-stg.com',
      owlinAdvanced: true,
      owlinEnv: 'staging',
    },
    defaults
  ),
  'app.fitchconnect-prd.com': _defaults(
    {
      base: 'https://app.fitchconnect-prd.com',
      apiUrl: 'api.fitchconnect-prd.com',
    },
    defaults
  ),
});
Object.freeze(envUrls);

export var urls = envUrls[window.location.host]
  ? envUrls[window.location.host]
  : envUrls[prodUrl];

export var getEnvironmentUrls = function (host = window.location.host) {
  // Default to production urls when not passed
  var env = host || prodUrl;

  // If still not working, return production
  return envUrls[env] ? envUrls[env] : envUrls[prodUrl];
};

export var setEnvironmentUrls = function (host = window.location.host) {
  urls = getEnvironmentUrls(host);
  return Promise.resolve(urls);
};

// update based on the PRO domain change
export const isHostRdr = () =>
  window.location.host.includes('rdr') || window.location.host.includes('pro');
